module.exports = __webpack_public_path__ + "img/card_sample2.3370214.png";